<template>
    <div>
        <my-form
        class="form-page"
        v-model="form"
        table
        label-width="160px"
        @cancle="cancleHandler"
        @submit="submitHandler"
        >

            <el-form-item
            label="标段名称"
            prop="bdname"
            :rules="newRule('标段名称', 'required')">
                <span>
                    {{form.bdname}}
                </span>
            </el-form-item>

            <el-form-item
            label="标段编码"
            prop="bdcode"
            :rules="newRule('标段编码', 'required')">
                <span>
                    {{form.bdcode}}
                </span>
            </el-form-item>

            <el-form-item
            label="评标委员会负责人"
            prop="e_pbfzr"
            >
                <span>
                    {{form.e_pbfzr}}
                </span>
            </el-form-item>

            <el-form-item
            label="评标委员会成员"
            prop="e_pbwy"
            >
                <span>
                    {{form.e_pbwy}}
                </span>
            </el-form-item>

            <el-form-item
            label="附件"
            class="table-full-row"
            prop="bdcodes">
                <div>
                    <el-radio-group v-model="filetype">
                        <el-radio :label="'word'">Word格式(.docx)评标报告（由平台自动转换为PDF格式</el-radio>
                        <el-radio :label="'pdf'">PDF格式(.pdf)评标报告</el-radio>
                    </el-radio-group>
                </div>
                <my-upload @update="getFileList" :upload-strict="true" :file-guid="curFileguid || ''" :extra="uploadExtra" :file-type="filetype == 'pdf' ? 'pdf' : 'docx'" :single="true" :file-size="30"></my-upload>
            </el-form-item>

            <el-form-item
            label="评标报告正文内容"
            class="table-full-row"
            prop="bgcontent"
            v-if="filetype == 'pdf'"
            :rules="newRule('评标报告正文内容', 'required','sensitiveWords')">
                <!-- <ueditor v-model="form.bgcontent"></ueditor> -->
                <kindeditor id="editor_id" height="500px" width="100%" :content.sync="form.bgcontent"></kindeditor>
            </el-form-item>
            
             
            <template slot="btn" slot-scope="scope">
                <el-button
                    @click="saveHandler(1, scope.submitHandler)"
                    type="primary"
                    icon="el-icon-circle-check">
                        保存
                </el-button>
            </template>
        </my-form>
    </div>
</template>
 
<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
export default {
    mixins: [ FORM_PAGE_MIXIN ],
    components: {  },
    data: () => ({
        form: {},
        isnzk:'',
        ptPlaceholder: window._config.title2,
        filetype:"",
        fileList:[],
        curFileguid:"",
        uploadExtra:{
            typecode:"",
        },
    }),    
    watch:{
        filetype:function(n){
            if(n == 'pdf'){
                this.curFileguid = !!this.form.fileguid ? this.form.fileguid : "";
                this.uploadExtra.typecode = "pbbgpdf";
            }else{
                this.curFileguid = !!this.form.by3 ? this.form.by3 : "";
                this.uploadExtra.typecode = "pbbgword";
            }
        }
    },                                                                                                  
    methods: {
        saveHandler(type, cb) {
            if(this.fileList.length < 1){
                ShowMsg('请上传附件','error');
                return
            }
            cb && cb();
        },
        submitHandler:function(){
            var that=this;
            var loading = this.$loading({
                lock:true,
                text:"正在保存",
                spinner:'el-icon-loading',
                background:'rgba(0,0,0,0.7)'
            });
            this.$ajax({
                url:`${this.getGetters('bidUrl')}/revision/kaibiao/pbbg/add.json`,
                type:"post",
                data:that.form,
                callback:function(data){
                    ShowMsg('保存成功','success');
                    loading.close();
                    that.goto({
                        path:'./list',
                        query:{
                            zbprocode:that.getQuery('zbprocode'),
                            zgys:that.getQuery('zgys'),
                        }
                    })
                },
                complete:function(){
                    loading.close();
                }
            })
        },        
        getFileList(list){
            this.fileList = list;
        }                                                                                                                 
    },
    created() {
        var that = this;
        this.$ajax({
            url:`${this.getGetters('bidUrl')}/revision/kaibiao/pbbg/edit.json`,
            type:"get",
            data:{
                bdcode:that.getQuery('bdcode'),
                bgcode:that.getQuery('bgcode'),
            },
            callback:function(data){
                that.form = data.model;
                if(data.model.shbj == '1'){
                    that.$alert('已经提交的评标报告，不能修改', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                            that.goto({
                                path:"./list",
                                query:{
                                    zbprocode:that.getQuery('zbprocode'),
                                    isXingTai:that.getQuery('isXingTai'),
                                    zgys:that.getQuery('zgys'),
                                }
                            })
                            return
                        }
                    });
                }
                that.form.shbj = "0";
                if(that.getQuery('type') == 'add'){
                    that.filetype = "word";
                }else{
                    that.filetype = "pdf";
                }
            }
        })
    },
    mounted(){
        
    }
}
</script>

<style scoped lang="scss">
    /deep/ .el-form-item__error{ bottom: auto !important; }
</style>
